var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoibenteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16926"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 32h32v-32h-32z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 42.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.8117 10h6.5701v11.169h-6.5701z",
    fill: "#008768"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.65701 0 0 .65701 3.1233 28.511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5v-2.174h-5z",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.65701 0 0 .65701 17.777 28.511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5v-2.174h-5z",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.65701 0 0 .65701 10.45 28.511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5v-2.174h-5z",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1.622 20.69h21.024v6.392h-21.024z",
    fill: "#008768"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.65701 0 0 .65701 1.622 9.9982)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16926)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.2531 24.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.285-4.567c0-1.522 1.142-2.283 2.283-2.283s2.283.761 2.283 2.283zm0-.559 2.03-4.066c-.029-1.356-1.067-1.975-2.032-1.975s-2.003.619-2.032 1.975z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8242 24.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.285-4.567c0-1.522 1.142-2.283 2.283-2.283s2.283.761 2.283 2.283zm0-.559 2.03-4.066c-.029-1.356-1.067-1.975-2.032-1.975s-2.003.619-2.032 1.975z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.389 24.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.285-4.567c0-1.522 1.142-2.283 2.283-2.283s2.283.761 2.283 2.283zm0-.559 2.03-4.066c-.029-1.356-1.067-1.975-2.032-1.975s-2.003.619-2.032 1.975z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.954 24.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.285-4.567c0-1.522 1.142-2.283 2.283-2.283s2.283.761 2.283 2.283zm0-.559 2.03-4.066c-.029-1.356-1.067-1.975-2.032-1.975s-2.003.619-2.032 1.975z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5727 23.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 2.178 3.935 2.178 3.935 0",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.9991 23.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 2.178 3.935 2.178 3.935 0",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.072 23.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 2.178-3.935 2.178-3.935 0",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.638 23.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 2.178-3.935 2.178-3.935 0",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.203 23.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 2.178-3.935 2.178-3.935 0",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.52 24.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.285-4.567c0-1.522 1.142-2.283 2.283-2.283s2.283.761 2.283 2.283zm0-.559 2.03-4.066c-.029-1.356-1.067-1.975-2.032-1.975s-2.003.619-2.032 1.975z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.091 24.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.285-4.567c0-1.522 1.142-2.283 2.283-2.283s2.283.761 2.283 2.283zm0-.559 2.03-4.066c-.029-1.356-1.067-1.975-2.032-1.975s-2.003.619-2.032 1.975z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.656 24.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.285-4.567c0-1.522 1.142-2.283 2.283-2.283s2.283.761 2.283 2.283zm0-.559 2.03-4.066c-.029-1.356-1.067-1.975-2.032-1.975s-2.003.619-2.032 1.975z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.221 24.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.285-4.567c0-1.522 1.142-2.283 2.283-2.283s2.283.761 2.283 2.283zm0-.559 2.03-4.066c-.029-1.356-1.067-1.975-2.032-1.975s-2.003.619-2.032 1.975z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.839 23.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 2.178 3.935 2.178 3.935 0",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.339 23.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 2.178-3.935 2.178-3.935 0",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.904 23.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 2.178-3.935 2.178-3.935 0",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.937 27.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-19.674",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoibenteIcon);
export default __webpack_public_path__ + "static/media/CoibenteIcon.225eb502d9e4dbdf22049d84766c3384.svg";
export { ForwardRef as ReactComponent };